import { all, takeEvery, put, fork, call } from "redux-saga/effects";
import {
	SIGNIN,
	SIGNOUT,
	SIGNUP,
	SIGNIN_WITH_GOOGLE,
	SIGNIN_WITH_FACEBOOK
} from "../constants/Auth";
import {
	showAuthMessage,
	authenticated,
	signOutSuccess,
	signUpSuccess,
	signInSuccess,
	setUser,
} from "../actions/Auth";

import JwtAuthService from "services/JwtAuthService";
import FirebaseService from "services/FirebaseService";
import { setThemeConfig } from "redux/actions";
import { useThemeSwitcher } from "react-css-theme-switcher";
import { THEME_CONFIG } from "configs/AppConfig";



export function* signInwithJWT() {
	yield takeEvery(SIGNIN, function* ({ payload }) {
		const { username, password } = payload;
		try {
			const user = yield call(JwtAuthService.login, {
				username: username,
				password: password,
			});


			if (user) {

				yield put(
					setUser({
						username: user.user,
						role: user.role,
						roles: user.roles,
						code: user.code,
						credit: user.credit,
						avatar: user.avatar
					})
				);

				yield put(
					setThemeConfig(user.themeConfig)
				);


				yield put(authenticated(true));
				yield put(signInSuccess());
			} else {
				yield put(showAuthMessage("Invalid credentials."));
			}

		} catch (err) {
			yield put(showAuthMessage(err));
		}
	});
}

export function* signOut() {
	yield takeEvery(SIGNOUT, function* () {
		try {

			yield put(signOutSuccess());
			yield put(
				setThemeConfig(THEME_CONFIG)
			);
			const signOutUser = yield call(FirebaseService.signOutRequest);
			const signOut = yield call(JwtAuthService.signOut);

		} catch (err) {
			yield put(showAuthMessage(err));
		}
	});
}

export function* signUpWithFBEmail() {
	yield takeEvery(SIGNUP, function* ({ payload }) {
		const { email, password } = payload;
		try {
			const user = yield call(
				FirebaseService.signUpEmailRequest,
				email,
				password
			);
			if (user.message) {
				yield put(showAuthMessage(user.message));
			} else {
				//localStorage.setItem(AUTH_TOKEN, user.user.uid);
				yield put(signUpSuccess(user.user.uid));
			}
		} catch (error) {
			yield put(showAuthMessage(error));
		}
	});
}

export function* signInWithFBGoogle() {
	yield takeEvery(SIGNIN_WITH_GOOGLE, function* () {
		try {
			const user = yield call(FirebaseService.signInGoogleRequest);
			if (user.message) {
				yield put(showAuthMessage(user.message));
			} else {
				var JwtUser = null;
				if (user.additionalUserInfo.isNewUser) {
					JwtUser = yield call(JwtAuthService.signUp, {
						username: user.user.displayName,
						password: user.user.uid,
					});
				} else {
					JwtUser = yield call(JwtAuthService.login, {
						username: user.user.displayName,
						password: user.user.uid,
					});
				}
				console.log(JwtUser);
				yield put(
					setUser({
						credit: JwtUser.credit,
						username: JwtUser.user,
						role: JwtUser.role,
						code: JwtUser.code,
					})
				);
				yield put(authenticated(true));
				yield put(signInSuccess());
			}
		} catch (error) {
			yield put(showAuthMessage(error));
		}
	});
}


export function* signInWithFacebook() {
	yield takeEvery(SIGNIN_WITH_FACEBOOK, function* () {
		try {
			const user = yield call(FirebaseService.signInFacebookRequest);

			if (user.message) {
				yield put(showAuthMessage(user.message));
			} else {
				var JwtUser = null;
				if (user.additionalUserInfo.isNewUser) {
					JwtUser = yield call(JwtAuthService.signUp, {
						username: user.user.displayName,
						password: user.user.uid,
					});
				} else {
					JwtUser = yield call(JwtAuthService.login, {
						username: user.user.displayName,
						password: user.user.uid,
					});
				}

				yield put(
					setUser({
						credit: JwtUser.credit,
						username: JwtUser.user,
						role: JwtUser.role,
						code: JwtUser.code,
					})
				);
				yield put(authenticated(true));
				yield put(signInSuccess());
			}
		} catch (error) {
			console.log(error);
			yield put(showAuthMessage(error.message));
		}
	});
}

export default function* rootSaga() {
	yield all([
		fork(signInwithJWT),
		fork(signOut),
		fork(signUpWithFBEmail),
		fork(signInWithFBGoogle),
		fork(signInWithFacebook),

	]);
}
